export default __webpack_public_path__ + "static/media/LinkedInColor.9d429a60.svg";